<template>
    <div class="relative">
        <div :disabled="disabled" ref="trigger" @click="onClick">
            <slot name="trigger" />
        </div>
        <nio-popup
            :full-width="false"
            :opened="isOpen"
            :placement="placement"
            :trigger="$refs.trigger"
            ref="panel"
            @clickin="onClickIn"
            @clickout="onClickOut"
        >
            <div class="overflow-auto" :class="maxHeightClassName">
                <slot />
            </div>
        </nio-popup>
    </div>
</template>

<script>
    import { elementContains } from '@/utils/dom.js';

    export default {
        props: {
            placement: {
                type: String,
                default: 'bottom',
            },
            closeOnSelect: {
                type: Boolean,
                default: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            maxHeightClassName: {
                type: String,
                default: 'max-h-80',
            },
        },

        data: () => ({
            isOpen: false,
        }),

        methods: {
            open() {
                this.$nextTick(() => {
                    this.isOpen = true;
                    this.$refs.panel.focus();
                });
            },

            close() {
                this.isOpen = false;
            },

            onClick() {
                if (this.disabled) {
                    return;
                }

                if (this.isOpen) {
                    this.close();
                } else {
                    this.open();
                }
            },

            onClickOut(e) {
                if (!elementContains(this.$refs.trigger, e.target)) {
                    this.close();
                }
            },

            onClickIn() {
                if (this.closeOnSelect) {
                    this.close();
                }
            },
        },
    };
</script>
